import { Dispatch, SetStateAction } from "react";
import { createContext } from "react";


export type TypeCurrentLanguageContext = {
    currentLanguage: string,
    setCurrentLanguage: Dispatch<SetStateAction<string>>
}
export const CurrentLanguageContext = createContext<TypeCurrentLanguageContext>({
    currentLanguage: 'fr',
    setCurrentLanguage: () => { }
})


